// extracted by mini-css-extract-plugin
export default {"customCardNavigation":"Custom_customCardNavigation__xGLYg","customButton":"Custom_customButton__fPFcN","customButtonText":"Custom_customButtonText__F521P"};